export default [
  {
    path: '/store',
    redirect: {name: 'goods-disposition-manage-index'}
  }
]
